import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
let loaded = false;

const isPublicPath = (pathname) => pathname !== "/admin" && !pathname.startsWith("/admin/");

// Loads the official Google tag once. The initial page_view comes from `config`, and
// client-side route changes are counted by GA4 Enhanced Measurement (browser history events),
// so no manual page_view is sent here (that would double count).
function loadGoogleTag() {
  if (loaded || !measurementId) return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", measurementId);
  if (document.querySelector('script[src^="https://www.googletagmanager.com/gtag/js"]')) return;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);
}

export default function GoogleAnalytics() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (loaded || !isPublicPath(pathname)) return;
    // Short delay so the first page_view carries titles that pages set after loading content.
    const timer = setTimeout(loadGoogleTag, 700);
    return () => clearTimeout(timer);
  }, [pathname]);
  return null;
}
